// extracted by mini-css-extract-plugin
export default {"loginContainer":"styles_loginContainer__zic2J","loginCard":"styles_loginCard__3-ETr","loginTitle":"styles_loginTitle__QGPR3"};